import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-6 left-0 right-0 flex justify-center z-50 px-4 animate-slide-up">
      <div className="bg-white border-2 border-slate-200 shadow-xl rounded-lg max-w-3xl w-auto">
        <div className="px-6 py-4">
          <div className="flex flex-col md:flex-row items-center gap-4">
            {/* Texto */}
            <div className="text-sm text-slate-700 text-center md:text-left">
              <p className="leading-relaxed">
                Este site usa cookies e processa dados conforme nossa{' '}
                <Link 
                  to="/politicas-de-privacidade-e-cookies" 
                  className="text-primary hover:underline font-medium"
                >
                  Política de Privacidade e Cookies
                </Link>.
              </p>
            </div>
            
            {/* ✅ Botão com classe primary (usa a cor do Tailwind config) */}
            <button
              onClick={acceptCookies}
              className="bg-primary hover:bg-slate-800 text-white px-6 py-2 text-sm font-medium transition-all whitespace-nowrap rounded"
            >
              Entendi
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;